<template lang="pug">
  .card.height-100
    .card-body
      .columns
        .column.col-3
          img.img-responsive(:src="banner.photoURL")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ banner.title }}
          .text-ellipsis {{ banner.description }}
          .mt-1.text-ellipsis
            a.text-small.text-error.text-ellipsis(:href="banner.action" target="_blank") {{ banner.action }}
            div Status: #[span.text-bold(:class="banner.active ? 'text-success' : 'text-error'") {{ banner.active ? 'Ativo' : 'Inativo' }}]
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ banner.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
            data-tooltip="Excluir"
            @click="$emit('remove', banner)"
          )
            i.fas.fa-trash-alt
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'banners.edit', params: { id: banner.id } }"
            data-tooltip="Editar"
          )
            i.fas.fa-edit
</template>

<script>
export default {
  props: {
    banner: { type: Object, required: true },
  },
}
</script>
